import * as AppPics from 'assets/images';
import TopicVideoTab from './Tabs/Videos';
import { useContext, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import useTopics from 'hooks/API/GET/useTopics';
import TopicStoryTab from './Tabs/Stories';
import TopicMindTreeTab from './Tabs/MindTree';
import TopicNotesTab from './Tabs/Notes';
import TopicGeekCornerTab from './Tabs/GeekCorner';
import useQueryParams from 'hooks/useQueryParams';
import DetailsHeader from 'components/molecules/DetailsHeader';
import { AppButton } from 'components';
import { UserContext } from 'context/UserContext';
import { useEffect } from 'react';
import TopicRatingHistory from './TopicRatingHistory';
import TopicSprintTab from './Tabs/sprint';
import TopicRevisionTab from './Tabs/Revision';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ManageMindmap from './Tabs/MindTree/ManageMindTree';
import { useLocation, useHistory } from 'react-router-dom';

function TopicContents() {
  const [tab, setTab] = useState('note');
  const query = useQueryParams();
  const subtopicID = query.get('subtopic');
  const currentTab = query.get('currentTab');
  const tabToBeOpened = query.get('open');

  const location = useLocation();
  const history = useHistory();

  const { path } = useRouteMatch();
  const userContext = useContext(UserContext);

  const { classID, courseID, chapterID, topicID } = useParams();

  const { isLoading, data, isError } = useTopics({
    classID,
    courseID,
    chapterID,
    topicID,
    enabled: true,
    configs: { params: { subtopicID } },
  });

  useEffect(() => {
    if (tabToBeOpened) setTab(tabToBeOpened);

    return () => {};
  }, [tabToBeOpened]);

  useEffect(() => {
    if (currentTab) setTab(currentTab);

    return () => {};
  }, [currentTab]);

  return (
    <div className="mainWraper">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <AppButton
              variantClass="btn-back"
              onClick={() => {
                if (location.pathname.includes('/mind-tree/add')) {
                  history.goBack();
                } else {
                  history.push(`/classes/${classID}/courses/${courseID}/chapters`);
                }
              }}
            >
              <img src={AppPics.BackSvg} alt="" />
            </AppButton>
          </li>
          <li className={tab === 'note' ? 'active' : ''} onClick={() => setTab('note')}>
            Notes
          </li>
          <li className={tab === 'video' ? 'active' : ''} onClick={() => setTab('video')}>
            Videos
          </li>
          <li className={tab === 'story' ? 'active' : ''} onClick={() => setTab('story')}>
            Stories
          </li>
          <li className={tab === 'sprint' ? 'active' : ''} onClick={() => setTab('sprint')}>
            Sprint
          </li>
          <li className={tab === 'revision' ? 'active' : ''} onClick={() => setTab('revision')}>
            Revision Note
          </li>
          <li className={tab === 'mindTree' ? 'active' : ''} onClick={() => setTab('mindTree')}>
            Mind Tree
          </li>
          <li className={tab === 'geekCorner' ? 'active' : ''} onClick={() => setTab('geekCorner')}>
            Geek Corner
          </li>
          <li className={tab === 'echo' ? 'active' : ''} onClick={() => setTab('echo')}>
            Echoes
          </li>
          {/* <li className={tab === 'cHistory' ? 'active' : ''} onClick={() => setTab('cHistory')}>
            Rating History - to be removed
          </li> */}
        </ul>

        {isLoading ? (
          'Loading...'
        ) : isError ? (
          'Failed to load data'
        ) : (
          <div className="tab__content ___adjust___tab___padding">
            {/* START: 1 */}
            <div className="tab__content-actHead">
              <DetailsHeader />
            </div>
            {/* END: 1 */}
            <div className="tab__content-actBody">
              {tab === 'video' && (
                <TopicVideoTab
                  userContext={userContext}
                  subtopicID={subtopicID}
                  data={data?.data}
                />
              )}
              {tab === 'story' && (
                <TopicStoryTab
                  userContext={userContext}
                  subtopicID={subtopicID}
                  data={data?.data}
                />
              )}
              {tab === 'mindTree' && (
                <Switch>
                  <Route exact path={path}>
                    {tab === 'mindTree' && (
                      <TopicMindTreeTab
                        userContext={userContext}
                        subtopicID={subtopicID}
                        data={data?.data}
                      />
                    )}
                  </Route>

                  <Route path={`${path}/mind-tree/add`}>
                    <ManageMindmap />
                  </Route>
                </Switch>
              )}
              {tab === 'note' && (
                <TopicNotesTab
                  userContext={userContext}
                  subtopicID={subtopicID}
                  data={data?.data}
                />
              )}
              {tab === 'geekCorner' && (
                <TopicGeekCornerTab
                  userContext={userContext}
                  subtopicID={subtopicID}
                  data={data?.data}
                />
              )}
              {tab === 'sprint' && <TopicSprintTab />}
              {tab === 'revision' && <TopicRevisionTab />}
              {/* {tab === 'cHistory' && <TopicRatingHistory data={data?.data} />} */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TopicContents;
